// extracted by mini-css-extract-plugin
export default {"applyToAll":"ApplyToAllButton_applyToAll__+vHnD","applyToAllButton":"ApplyToAllButton_applyToAllButton__ysekh"};